<script lang="ts">
  import MediaCredit from '../MediaCredit.svelte'
  import type { SerializedImageBlock } from '../../types'

  let { block, priority = false }: { block: SerializedImageBlock; priority?: boolean } = $props()
</script>

<figure class="image-block">
  <div class="image-block-media">
    <img class="image-block-photo" src={block.image.src} srcset={block.image.srcset} sizes="(max-width: 744px) 100vw, 720px" width={block.image.width} height={block.image.height} alt={block.altText} loading={priority ? 'eager' : 'lazy'} fetchpriority={priority ? 'high' : undefined} />
    <MediaCredit />
  </div>
  {#if block.caption}
    <figcaption class="image-block-caption">{block.caption}</figcaption>
  {/if}
</figure>

<style>
  .image-block {
    grid-column: full;
    display: grid;
    grid-template-columns: subgrid;
  }

  .image-block-media {
    grid-column: content;
    position: relative;
  }

  .image-block-photo {
    display: block;
    width: 100%;
    height: auto;
    border-radius: var(--radius-3);
  }

  .image-block-caption {
    grid-column: content;
  }

  @media (--mobile) {
    .image-block-media {
      grid-column: full;
    }

    .image-block-photo {
      border-radius: 0;
    }
  }
</style>
